import { t } from "@/i18n-js/instance";
import { ROOM_TYPES } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { Room } from "@circle-react/types/Live/Room";
import { Toolbar } from "../../Toolbar";
import { ClosingIndicator } from "../Indicators/ClosingIndicator";
import { ElapsedTimeIndicator } from "../Indicators/ElapsedTimeIndicator";
import { InitializingIndicator } from "../Indicators/InitializingIndicator";
import { LiveIndicator } from "../Indicators/LiveIndicator";
import { RecordingIndicator } from "../Indicators/RecordingIndicator";
import { useRoomStatus } from "./useRoomStatus";

export const StatusBar = ({ room }: { room: Room }) => {
  const {
    isStream,
    isInitializing,
    isClosing,
    isLive,
    isRecording,
    isBackstage,
    liveAt,
  } = useRoomStatus(room);
  const roomType = room?.room_type || ROOM_TYPES.STREAM;

  return (
    <>
      {isStream && isBackstage && (
        <Toolbar.Indicator
          label={t("live_streams.room.backstage_indicator")}
          disabled
        />
      )}
      {isInitializing && <InitializingIndicator />}
      {isClosing && <ClosingIndicator roomType={roomType} />}
      {liveAt && <ElapsedTimeIndicator liveAt={liveAt} />}
      {isRecording && <RecordingIndicator />}
      {isStream && isLive && <LiveIndicator />}
    </>
  );
};
